import { useState } from 'react';
import useGetCategoria from '../../hook/useGetCategoria';
import Menu from '../Listas/Menu.jsx';
import { Typography } from '@material-tailwind/react';
import AddButton from '../Buttons/AddButton.jsx';
import { AddModalCatLn } from '../Modal/AddModalCatLn.jsx';
import { useDispatch } from 'react-redux';
import { getCategoria as newCategoria } from '../../slices/getCategoria.js';

const CategoriasLinhas = ({ title }) => {
  const [modal, setModal] = useState(false);
  const { result, getCategorias } = useGetCategoria();
  const dispatch = useDispatch();

  const handleModel = () => {
    setModal(!modal);
  };

  const handleNewResult = () => {
    getCategorias();
    dispatch(newCategoria());
  };

  return (
    <div className="w-full flex flex-col gap-2 min-w-64 sm:w-52 sm:h-[100%] flex-1 bg-transparent dark:bg-darkColorBox dark:border dark:border-darkColorBorder rounded-xl shadow-darkShadow">
      <Typography
        variant="h5"
        className="p-3 dark:text-darkText dark:italic  border-b dark:border-darkColorHr"
      >
        {title}
        <AddButton handleModel={handleModel} />
      </Typography>
      <div className="overflow-auto space-y-2 global-scrollbar ">
        {result &&
          Object.entries(result).map(([key, item], index) => (
            <Menu item={item} key={index} news={handleNewResult} />
          ))}
      </div>
      <AddModalCatLn
        modal={modal}
        handleModal={handleModel}
        url="categoriaCompra"
        id=""
        title={`Cadastrar categoria`}
        news={handleNewResult}
      />
    </div>
  );
};

export default CategoriasLinhas;
